import { Component } from '@angular/core';

@Component({
    selector: 'tools',
    templateUrl: './tools.component.html',
    styleUrls: ['tools.component.scss'],
    standalone: false
})
export class WidgetsComponent {}
